import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import { useTheme } from "./ThemeInjector";

export function NotFoundPage() {
  const theme = useTheme();

  return (
    <div className="pt-24 pb-24 px-6 max-w-2xl mx-auto text-center">
      <img
        src="/404.png"
        alt=""
        className="w-48 h-auto mx-auto mb-8"
        style={{ maxHeight: "280px", objectFit: "contain" }}
      />
      <p
        className="tracking-[0.3em] uppercase mb-2"
        style={{ fontFamily: theme.fontBody, fontSize: "12px", color: theme.accent }}
      >
        404
      </p>
      <h1
        className="tracking-[0.1em] mb-4"
        style={{ fontFamily: theme.fontHeading, fontSize: "clamp(28px, 4vw, 42px)", fontWeight: 400, color: theme.fg }}
      >
        Page Not Found
      </h1>
      <p
        className="leading-[1.8] mb-10 max-w-md mx-auto"
        style={{ fontFamily: theme.fontBody, fontSize: "15px", fontWeight: 300, color: theme.muted }}
      >
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-8 py-3 tracking-[0.2em] uppercase transition-all duration-300"
        style={{
          fontFamily: theme.fontBody,
          fontSize: "12px",
          fontWeight: 400,
          backgroundColor: theme.btnBg,
          color: theme.btnText,
          borderRadius: theme.btnRadius,
        }}
      >
        <ArrowLeft size={14} />
        Back to Home
      </Link>
    </div>
  );
}
